import { Filesystem, Directory, Encoding } from '@capacitor/filesystem'
import { Share } from '@capacitor/share'
import { platform } from './nativeBridge'

// Where logs go:
//   android  app-specific external storage, Android/data/<appId>/files/gate1/
//            (adb pull works there on a non-debuggable build)
//   ios      Documents/gate1/ (Files app and Finder; see Info.plist)
//   web      the plugin's IndexedDB, plus window.__gate1 and a download button
const DIR = 'gate1'
const directory = platform === 'android' ? Directory.External : platform === 'ios' ? Directory.Documents : Directory.Data

const webLogs = []
if (platform === 'web') window.__gate1 = { logs: webLogs }

export async function writeLog(name, log) {
    const data = JSON.stringify(log)
    await Filesystem.writeFile({ path: `${DIR}/${name}`, data, directory, encoding: Encoding.UTF8, recursive: true })
    if (platform === 'web') webLogs.push({ name, log })
    return { name, bytes: data.length }
}

export async function listLogs() {
    try {
        const r = await Filesystem.readdir({ path: DIR, directory })
        return r.files.map(f => ({ name: f.name, size: f.size, mtime: f.mtime })).sort((a, b) => (a.name < b.name ? 1 : -1))
    } catch {
        return []
    }
}

// A PNG (data URL) next to the logs, e.g. a scene screenshot.
export async function writePng(name, dataUrl) {
    const data = dataUrl.replace(/^data:image\/png;base64,/, '')
    await Filesystem.writeFile({ path: `${DIR}/${name}`, data, directory, recursive: true })
    if (platform === 'web') webLogs.push({ name, log: { png: name, bytes: data.length } })
    return { name, bytes: Math.round((data.length * 3) / 4) }
}

// Share-sheet export of every log (the fallback to adb pull / Files app).
export async function exportLogs(extra = []) {
    const files = await listLogs()
    if (platform === 'web') {
        for (const { name, log } of webLogs) download(name, JSON.stringify(log))
        for (const { name, data } of extra) download(name, data)
        return { count: webLogs.length + extra.length }
    }
    for (const { name, data } of extra) {
        await Filesystem.writeFile({ path: `${DIR}/${name}`, data, directory, encoding: Encoding.UTF8, recursive: true })
    }
    const names = [...new Set([...files.map(f => f.name), ...extra.map(e => e.name)])]
    const uris = await Promise.all(names.map(n => Filesystem.getUri({ path: `${DIR}/${n}`, directory }).then(r => r.uri)))
    if (uris.length === 0) return { count: 0 }
    await Share.share({ title: 'Gate 1 logs', files: uris })
    return { count: uris.length }
}

function download(name, data) {
    const url = URL.createObjectURL(new Blob([data], { type: 'application/json' }))
    const a = Object.assign(document.createElement('a'), { href: url, download: name })
    document.body.appendChild(a)
    a.click()
    a.remove()
    setTimeout(() => URL.revokeObjectURL(url), 1000)
}
